import React, { memo } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import "../ModalInformacao/ModalInformacao.css";
import CustomButton from "../CustomButton/CustomButton";

export interface SimpleDialogProps {
	titulo: string;
	tituloBotao: string;
	open: boolean;
	onClose: () => void;
	onClick: () => void;
}

function ModalInformacao({
	open = false,
	titulo,
	tituloBotao,
	onClose,
}: SimpleDialogProps) {
	return (
		<div>
			<Dialog open={open} onClose={onClose}>
				<div className="div-modal-usuario">
					<DialogTitle id="alert-dialog-title">{titulo}</DialogTitle>
					<DialogActions>
						<CustomButton
							titulo={tituloBotao}
							cor={tituloBotao === "OK" ? "primary" : "secondary"}
						/>
					</DialogActions>
				</div>
			</Dialog>
		</div>
	);
}
export default memo(ModalInformacao);
